// @flow
import {
  FACILITY_DETAILS_REQUEST,
  FACILITY_DETAILS_UPDATE,
  FACILITY_DETAILS_ERROR,
  FACILITY_DETAILS_RESET
} from './constants';

import { connectIncludedData } from './utils';

import type { State, Action } from '../types';

const initialState: State = {
  requesting: false,
  data: undefined,
  slug: undefined
};

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case FACILITY_DETAILS_REQUEST:
      return { ...state, requesting: true, slug: action.slug };
    case FACILITY_DETAILS_UPDATE:
      return {
        ...state,
        requesting: false,
        data: action.data && connectIncludedData(action.data, action.included || [])
      };
    case FACILITY_DETAILS_ERROR:
      return { ...state, requesting: false };
    case FACILITY_DETAILS_RESET:
      return initialState;
    default:
      return state;
  }
};
